import {
  Badge,
  Box,
  Button,
  Flex,
  Link,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect } from "react";

import { HamburgerIcon, Icon } from "@chakra-ui/icons";
import { updateDomainKey } from "app/slice/globalSettingsSlice";
import { FaUserAlt, FaUserCircle } from "react-icons/fa";
import { HiOutlineLogout } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import Auth from "../../Auth/Auth";
import ChangePasswordeModal from "./ChangePasswordModal";

export const logoutHandler = (timeOut = 0) => {
  setTimeout(() => {
    Auth.signout(() => {
      localStorage.clear();
      window.location.replace("/");
    });
  }, timeOut);
};

function Header({ handleNavState, toggleShowAdminData, showAdminData }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();

  const globalSettings = useSelector((state) => state.globalSettings);

  useEffect(() => {
   
      const domain = localStorage.getItem("domainKey");
      dispatch(updateDomainKey(domain));
    
  }, []);

  const visitDomain = localStorage.getItem("domainOrigin");

  return (
    <>
      <Box bg="#f8f8f8" h="50px" shadow="md">
        {/* <iframe
          id="ifr"
          style={{ display: 'none' }}
          src="http://bbn.localhost:3001/localStorage"></iframe> */}
        <Flex h="100%">
          <Box w="100px">
            {window.innerWidth <= 600 && (
              <HamburgerIcon
                w={5}
                h={10}
                ml={15}
                mt="10px"
                cursor="pointer"
                alignSelf="flex-start"
                onClick={handleNavState}
              />
            )}
          </Box>
          <Flex justifyContent="flex-end" alignItems="center" w="100%">
            {globalSettings?.activeDomain ? (
             <Flex alignItems='center' gap={2} mr={2}>
             <Text  
             fontWeight={500}
                color="blue.500"
             fontSize='sm'>Active Domain:</Text>
                <Badge borderRadius='4px' p={0.5} colorScheme="blue"  key={localStorage.getItem("domainKey")}>
                  {globalSettings?.activeDomain}
                </Badge>
             </Flex>
            ) : null}
            <Link
              href={visitDomain}
              isExternal
              textDecoration="none !important"
              mr="10px"
            >
              <Button
                colorScheme="blue"
                variant="outline"
                rounded="md"
                size="sm"
                fontSize="sm"
              >
                Visit Website
              </Button>
            </Link>

            <Icon
              w={5}
              h={10}
              mr={15}
              as={FaUserCircle}
              cursor="pointer"
              onClick={() => toggleShowAdminData()}
            />
          </Flex>
        </Flex>

        {showAdminData && (
          <Box
            w="300px"
            bg="white"
            borderTop="3px solid teal"
            ml="auto"
            mr="10px"
            mt="8px"
            rounded="lg"
            boxShadow="lg"
            position="relative"
            zIndex="2"
          >
            <Flex p={4} flexWrap="wrap">
              <Icon
                as={FaUserAlt}
                w={30}
                h={30}
                mr="10px"
                color="blue.600"
                mt="5px"
              />
              <Box>
                <Text fontSize="0.9rem">{localStorage.getItem("name")}</Text>
                <Text fontSize="0.9rem">{localStorage.getItem("email")}</Text>
              </Box>
            </Flex>

            <Box w="100%" h="3px" bg="#718096" />

            <Box p={4} mt={2}>
              <Flex
                cursor="pointer"
                _hover={{ color: "blue.500" }}
                onClick={() => {
                  toggleShowAdminData();
                  onOpen();
                }}
              >
                <Icon
                  w={5}
                  h={5}
                  mr="10px"
                  as={FaUserCircle}
                  color="blue.600"
                />
                <Text fontSize="0.8rem">Change Password</Text>
              </Flex>
              <Flex
                mt={3}
                onClick={logoutHandler}
                cursor="pointer"
                _hover={{ color: "red.500" }}
              >
                <Icon
                  w={5}
                  h={5}
                  mr="10px"
                  as={HiOutlineLogout}
                  color="red.500"
                />
                <Text fontSize="0.8rem">Logout</Text>
              </Flex>
            </Box>
          </Box>
        )}
      </Box>

      <ChangePasswordeModal
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        logoutHandler={logoutHandler}
      />
    </>
  );
}

export default Header;
